
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as d2FzbTpqcy1zdHJpbmc from './Scoreflection-webApp.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;
let require;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    const module = await import(/* webpackIgnore: true */'node:module');
    const importMeta = import.meta;
    require = module.default.createRequire(importMeta.url);
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'kotlinx.coroutines.internal.throwAsyncJsError' : (message, className, stack) => { 
            var error = new Error();
            error.message = message;
            error.name = className;
            error.stack = stack;
            if (typeof globalThis.reportError === 'function') {
                // Up-to-date browsers and some non-browser JS runtimes (Deno, Bun)
                globalThis.reportError(error);
            } else {
                // Fallback for old browsers (pre-2022), Node.js
                setTimeout(function () { throw error }, 0);
            }
         },
    'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.Int8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
    'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.Event_$external_class_get' : () => Event,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
    'org.w3c.dom.events.MouseEvent_$external_class_get' : () => MouseEvent,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
    'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.OPEN_$external_prop_getter' : (_this) => _this.OPEN,
    'org.w3c.dom.Companion_$external_object_getInstance' : () => WebSocket,
    'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
    'org.w3c.dom.readyState_$external_prop_getter_1' : (_this) => _this.readyState,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
    'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
    'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.Node_$external_class_instanceof' : (x) => x instanceof Node,
    'org.w3c.dom.Node_$external_class_get' : () => Node,
    'org.w3c.dom.Companion_$external_object_getInstance_2' : () => ({}),
    'org.w3c.dom.append_$external_fun' : (_this, p0) => _this.append(...p0),
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.identifier_$external_prop_getter' : (_this) => _this.identifier,
    'org.w3c.dom.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.Touch_$external_class_instanceof' : (x) => x instanceof Touch,
    'org.w3c.dom.Touch_$external_class_get' : () => Touch,
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.Companion_$external_object_getInstance_3' : () => ({}),
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.targetTouches_$external_prop_getter' : (_this) => _this.targetTouches,
    'org.w3c.dom.changedTouches_$external_prop_getter' : (_this) => _this.changedTouches,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
    'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
    'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
    'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
    'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.files.slice_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.slice(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'org.w3c.xhr.XMLHttpRequest_$external_fun' : () => new XMLHttpRequest(),
    'org.w3c.xhr.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.xhr.open_$external_fun' : (_this, p0, p1, p2, p3, p4, isDefault0, isDefault1) => _this.open(p0, p1, p2, isDefault0 ? undefined : p3, isDefault1 ? undefined : p4, ),
    'org.w3c.xhr.send_$external_fun' : (_this, ) => _this.send(),
    'org.w3c.xhr.overrideMimeType_$external_fun' : (_this, p0) => _this.overrideMimeType(p0),
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.w3c.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.skiko.w3c.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.jetbrains.skiko.w3c.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.jetbrains.skiko.w3c.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.jetbrains.skiko.w3c.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.jetbrains.skiko.w3c.open_$external_fun' : (_this, p0, p1) => _this.open(p0, p1),
    'org.jetbrains.skiko.w3c.window_$external_object_getInstance' : () => window,
    'org.jetbrains.skiko.w3c.now_$external_fun' : (_this, ) => _this.now(),
    'org.jetbrains.skiko.w3c.width_$external_prop_getter' : (_this) => _this.width,
    'org.jetbrains.skiko.w3c.height_$external_prop_getter' : (_this) => _this.height,
    'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
    'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
    'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
    'androidx.compose.ui.platform.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'androidx.compose.ui.platform.InputEvent_$external_class_get' : () => InputEvent,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.force_$external_prop_getter' : (_this) => _this.force,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.isInTestEnvironment' : () => window.composeResourcesTesting == true,
    'org.jetbrains.compose.resources.requestResponseAsByteArray' : (req) =>  {
            var text = req.responseText;
            var int8Arr = new Int8Array(text.length);
            for (var i = 0; i < text.length; i++) {
                int8Arr[i] = text.charCodeAt(i) & 0xFF;
            }
            return int8Arr;
        },
    'org.jetbrains.compose.resources.jsExportInt8ArrayToWasm' :  (src, size, dstAddr) => {
            const mem8 = new Int8Array(wasmExports.memory.buffer, dstAddr, size);
            mem8.set(src);
        }
    ,
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'com.codesient.scoreflection.platform.timezoneOffsetMinutes' : () => new Date().getTimezoneOffset(),
    'com.codesient.scoreflection.platform.localYmd' : () => (function(){var d=new Date();return d.getFullYear()*10000+(d.getMonth()+1)*100+d.getDate();})(),
    'com.codesient.scoreflection.platform.dateNow' : () => Date.now(),
    'com.codesient.scoreflection.platform.lsSetItem' : (key, value) => { window.localStorage.setItem(key, value) },
    'com.codesient.scoreflection.platform.lsGetItem' : (key) => window.localStorage.getItem(key),
    'com.codesient.scoreflection.platform.browserLanguage' : () => navigator.language || 'en',
    'com.codesient.scoreflection.platform.installIdb' : () => {
            if (window.__sfdb) return;
            const H = { db: null, queue: [] };
            window.__sfdb = H;
            H.apply = (op) => {
                try {
                    const store = H.db.transaction('files', 'readwrite').objectStore('files');
                    if (op.k === 'put') store.put({ p: op.p, v: op.v, d: op.d });
                    else store.delete(op.p);
                } catch (e) { /* a failed write costs persistence, never the session */ }
            };
            H.write = (op) => { if (H.db) H.apply(op); else H.queue.push(op); };
            H.open = (onDone, onFail) => {
                let request;
                try { request = indexedDB.open('scoreflection', 1); } catch (e) { onFail(); return; }
                request.onupgradeneeded = () => {
                    const db = request.result;
                    if (!db.objectStoreNames.contains('files')) {
                        db.createObjectStore('files', { keyPath: 'p' });
                    }
                };
                request.onerror = () => onFail();
                request.onblocked = () => onFail();
                request.onsuccess = () => {
                    H.db = request.result;
                    for (const op of H.queue) H.apply(op);
                    H.queue = [];
                    try {
                        const all = H.db.transaction('files', 'readonly').objectStore('files').getAll();
                        all.onerror = () => onFail();
                        all.onsuccess = () => onDone(JSON.stringify(all.result || []));
                    } catch (e) { onFail(); }
                };
            };
        },
    'com.codesient.scoreflection.platform.idbOpen' : (onDone, onFail) => window.__sfdb.open(onDone, onFail),
    'com.codesient.scoreflection.platform.lsDumpFsKeys' : () => {
            const out = [];
            for (let i = 0; i < window.localStorage.length; i++) {
                const key = window.localStorage.key(i);
                if (key && key.indexOf('fs:') === 0) {
                    out.push({ p: key.substring(3), v: window.localStorage.getItem(key) });
                }
            }
            return JSON.stringify(out);
        },
    'com.codesient.scoreflection.platform.lsRemove' : (key) => window.localStorage.removeItem(key),
    'com.codesient.scoreflection.platform.idbPut' : (path, value, isDirectory) => window.__sfdb.write({ k: 'put', p: path, v: value, d: isDirectory }),
    'com.codesient.scoreflection.platform.idbDelete' : (path) => window.__sfdb.write({ k: 'del', p: path }),
    'com.codesient.scoreflection.music.sound.sf2Install' : () => {
            if (!window.__mpsSynthCtx || window.__mpsSynthCtx.state === 'closed') {
                window.__mpsSynthCtx = new (window.AudioContext || window.webkitAudioContext)();
                if (window.__sfSampler) window.__sfSampler.out = null;
            }
            if (window.__mpsSynthCtx.state === 'suspended') window.__mpsSynthCtx.resume();
            if (window.__sfSampler) return;

            const S = {
                font: null, loading: null, defaultMods: true, voices: [], channels: [], out: null,
            };
            window.__sfSampler = S;

            // ---- SF2 parsing (RIFF sfbk: sdta/smpl + pdta hydra) -----------------------
            // Generators an instrument zone gives absolutely and a preset zone adds to.
            const DEFAULTS = { 8: 13500, 21: -12000, 22: -12000, 25: -12000, 26: -12000, 27: -12000,
                28: -12000, 30: -12000, 33: -12000, 34: -12000, 35: -12000, 36: -12000, 38: -12000,
                56: 100, 46: -1, 47: -1, 58: -1 };
            // Instrument-only generators: a preset zone may not offset these.
            const INST_ONLY = { 0: 1, 1: 1, 2: 1, 3: 1, 4: 1, 12: 1, 45: 1, 46: 1, 47: 1, 50: 1, 54: 1, 57: 1, 58: 1 };

            function parse(buf) {
                const dv = new DataView(buf), u8 = new Uint8Array(buf);
                const tag = o => String.fromCharCode(u8[o], u8[o + 1], u8[o + 2], u8[o + 3]);
                const name = o => { let s = ''; for (let i = 0; i < 20 && u8[o + i]; i++) s += String.fromCharCode(u8[o + i]); return s; };
                if (tag(0) !== 'RIFF' || tag(8) !== 'sfbk') throw new Error('not an SF2');
                const ch = {};
                const end = Math.min(buf.byteLength, 8 + dv.getUint32(4, true));
                for (let o = 12; o + 8 <= end;) {
                    const sz = dv.getUint32(o + 4, true);
                    if (tag(o) === 'LIST') {
                        for (let p = o + 12, e = o + 8 + sz; p + 8 <= e;) {
                            const s2 = dv.getUint32(p + 4, true);
                            ch[tag(p)] = { o: p + 8, n: s2 };
                            p += 8 + s2 + (s2 & 1);
                        }
                    }
                    o += 8 + sz + (sz & 1);
                }
                for (const k of ['smpl', 'phdr', 'pbag', 'pgen', 'inst', 'ibag', 'igen', 'shdr']) {
                    if (!ch[k]) throw new Error('SF2 missing ' + k);
                }
                const rows = (k, size) => { const c = ch[k], out = []; for (let i = 0; i + size <= c.n; i += size) out.push(c.o + i); return out; };
                const gens = (k) => rows(k, 4).map(o => ({ op: dv.getUint16(o, true), lo: u8[o + 2], hi: u8[o + 3], v: dv.getInt16(o + 2, true) }));
                const bags = (k) => rows(k, 4).map(o => dv.getUint16(o, true));
                const pgen = gens('pgen'), igen = gens('igen'), pbag = bags('pbag'), ibag = bags('ibag');
                const shdr = rows('shdr', 46).map(o => ({
                    start: dv.getUint32(o + 20, true), end: dv.getUint32(o + 24, true),
                    loopStart: dv.getUint32(o + 28, true), loopEnd: dv.getUint32(o + 32, true),
                    rate: dv.getUint32(o + 36, true), root: u8[o + 40], corr: dv.getInt8(o + 41), type: dv.getUint16(o + 44, true),
                }));
                const inst = rows('inst', 22).map(o => dv.getUint16(o + 20, true));
                const phdr = rows('phdr', 38).map(o => ({ name: name(o), program: dv.getUint16(o + 20, true), bank: dv.getUint16(o + 22, true), bag: dv.getUint16(o + 24, true) }));

                // Zones of one preset or instrument: [{gens, key:[lo,hi], vel:[lo,hi], link}],
                // the first returned separately when it is the global zone (no link generator).
                function zones(bagFrom, bagTo, bagTable, genTable, linkOp) {
                    const list = [];
                    for (let b = bagFrom; b < bagTo; b++) {
                        const z = { g: {}, key: [0, 127], vel: [0, 127], link: -1 };
                        for (let i = bagTable[b]; i < bagTable[b + 1]; i++) {
                            const gn = genTable[i];
                            if (gn.op === 43) z.key = [gn.lo, gn.hi];
                            else if (gn.op === 44) z.vel = [gn.lo, gn.hi];
                            else if (gn.op === linkOp) z.link = gn.v & 0xFFFF;
                            else z.g[gn.op] = gn.v;
                        }
                        list.push(z);
                    }
                    let global = null;
                    if (list.length && list[0].link < 0) global = list.shift();
                    return { global, list: list.filter(z => z.link >= 0) };
                }

                const instZones = [];
                for (let i = 0; i + 1 < inst.length; i++) instZones.push(zones(inst[i], inst[i + 1], ibag, igen, 53));

                const presets = [];
                for (let p = 0; p + 1 < phdr.length; p++) {
                    const pz = zones(phdr[p].bag, phdr[p + 1].bag, pbag, pgen, 41);
                    const regions = [];
                    for (const z of pz.list) {
                        const iz = instZones[z.link];
                        if (!iz) continue;
                        const pg = Object.assign({}, pz.global ? pz.global.g : {}, z.g);
                        const pk = (z.key[0] !== 0 || z.key[1] !== 127 || !pz.global) ? z.key : pz.global.key;
                        const pv = (z.vel[0] !== 0 || z.vel[1] !== 127 || !pz.global) ? z.vel : pz.global.vel;
                        for (const y of iz.list) {
                            const sh = shdr[y.link];
                            if (!sh || (sh.type & 0x8000)) continue; // ROM samples are not in the file
                            const g = Object.assign({}, DEFAULTS, iz.global ? iz.global.g : {}, y.g);
                            for (const k in pg) if (!INST_ONLY[k]) g[k] = (g[k] || 0) + pg[k];
                            const ik = (y.key[0] !== 0 || y.key[1] !== 127 || !iz.global) ? y.key : iz.global.key;
                            const iv = (y.vel[0] !== 0 || y.vel[1] !== 127 || !iz.global) ? y.vel : iz.global.vel;
                            regions.push({
                                keyLo: Math.max(pk[0], ik[0]), keyHi: Math.min(pk[1], ik[1]),
                                velLo: Math.max(pv[0], iv[0]), velHi: Math.min(pv[1], iv[1]),
                                g: g, sample: y.link,
                            });
                        }
                    }
                    presets.push({ name: phdr[p].name, bank: phdr[p].bank, program: phdr[p].program, regions });
                }
                const smpl = new Int16Array(buf, ch.smpl.o, ch.smpl.n >> 1);
                return { presets, shdr, smpl, buffers: {} };
            }

            S.load = function (url) {
                if (S.loading === url) return;
                S.loading = url;
                fetch(url)
                    .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.arrayBuffer(); })
                    .then(buf => { if (S.loading === url) S.font = parse(buf); })
                    .catch(e => { console.warn('[sf2] soundfont unavailable, keeping the oscillator', url, e); if (S.loading === url) S.loading = null; });
            };

            // ---- Playback ----------------------------------------------------------------
            const tc2s = tc => Math.pow(2, tc / 1200);

            function output() {
                const ctx = window.__mpsSynthCtx;
                if (S.out && S.out.context === ctx) return S.out;
                // tsf_set_volume(1.4) then SynthEngine's look-ahead limiter at -1 dBFS.
                const master = ctx.createGain();
                master.gain.value = 1.4;
                const lim = ctx.createDynamicsCompressor();
                lim.threshold.value = -1; lim.knee.value = 0; lim.ratio.value = 20;
                lim.attack.value = 0.002; lim.release.value = 0.15;
                master.connect(lim); lim.connect(ctx.destination);
                S.out = master;
                S.channels = [];
                return master;
            }

            function channel(c) {
                output();
                let ch = S.channels[c];
                if (!ch) {
                    const ctx = window.__mpsSynthCtx;
                    const vol = ctx.createGain();
                    const pan = ctx.createStereoPanner();
                    vol.connect(pan); pan.connect(S.out);
                    ch = S.channels[c] = { vol, pan, program: (S.programs && S.programs[c]) || 0, cc7: 127, cc11: 127, sustain: false };
                }
                return ch;
            }

            S.programs = [];
            S.setProgram = function (c, p) { S.programs[c] = p; if (S.channels[c]) S.channels[c].program = p; };

            function findPreset(c, program) {
                const f = S.font, bank = c === 9 ? 128 : 0;
                const by = (b, p) => f.presets.find(x => x.bank === b && x.program === p);
                return by(bank, program) || (bank === 128 ? by(128, 0) : null) || by(0, program) || by(0, 0) || f.presets[0];
            }

            function bufferFor(i) {
                const f = S.font;
                if (f.buffers[i]) return f.buffers[i];
                const sh = f.shdr[i], n = Math.max(1, sh.end - sh.start);
                const b = window.__mpsSynthCtx.createBuffer(1, n, Math.min(Math.max(sh.rate, 3000), 384000));
                const d = b.getChannelData(0);
                for (let k = 0; k < n; k++) d[k] = f.smpl[sh.start + k] / 32768;
                return (f.buffers[i] = b);
            }

            // Envelope level 0..1 at time t, for releasing from wherever the curve is.
            function levelAt(v, t) {
                const e = v.env;
                if (t < e.a0) return 0;
                if (t < e.a1) return (t - e.a0) / Math.max(1e-6, e.a1 - e.a0);
                if (t < e.h1) return 1;
                return e.sus + (1 - e.sus) * Math.exp(-(t - e.h1) / e.tau);
            }

            function release(v, t, fast) {
                if (v.released) return;
                v.released = true;
                const g = v.amp.gain;
                const lvl = levelAt(v, t) * v.peak;
                const rel = fast ? 0.005 : v.env.rel;
                g.cancelScheduledValues(t);
                g.setValueAtTime(lvl, t);
                g.setTargetAtTime(0, t, rel / 9.226);
                try { v.src.stop(t + rel + 0.05); } catch (e) {}
            }

            function startVoice(c, key, vel, when) {
                const f = S.font, ctx = window.__mpsSynthCtx;
                const ch = channel(c);
                const preset = findPreset(c, ch.program);
                const v01 = vel / 127;
                const started = [];
                for (const r of preset.regions) {
                    if (key < r.keyLo || key > r.keyHi || vel < r.velLo || vel > r.velHi) continue;
                    const g = r.g, sh = f.shdr[r.sample];
                    if (g[57]) {
                        for (const o of S.voices) if (o.ch === c && o.excl === g[57] && !o.released) release(o, when, true);
                    }
                    const buf = bufferFor(r.sample);
                    const src = ctx.createBufferSource();
                    src.buffer = buf;
                    const root = g[58] >= 0 ? g[58] : sh.root;
                    const k = g[46] >= 0 ? g[46] : key;
                    const cents = (k - root) * g[56] + (g[51] || 0) * 100 + (g[52] || 0) + sh.corr;
                    src.playbackRate.value = Math.pow(2, cents / 1200);
                    const startOff = (g[0] || 0) + 32768 * (g[4] || 0);
                    const mode = (g[54] || 0) & 3;
                    if (mode === 1 || mode === 3) {
                        const ls = sh.loopStart - sh.start + (g[2] || 0) + 32768 * (g[45] || 0);
                        const le = sh.loopEnd - sh.start + (g[3] || 0) + 32768 * (g[50] || 0);
                        if (le > ls && ls >= 0) {
                            src.loop = true;
                            src.loopStart = ls / buf.sampleRate;
                            src.loopEnd = le / buf.sampleRate;
                        }
                    }

                    // tsf_note_on: globalGainDB - attenuation - (default mods ? 2 : 1) * 20log10(1/vel).
                    const vk = g[47] >= 0 ? g[47] / 127 : v01;
                    const db = -(g[48] || 0) / 10 - (S.defaultMods ? 2 : 1) * 20 * Math.log10(1 / Math.max(vk, 1e-3));
                    const peak = Math.pow(10, db / 20);

                    let node = src;
                    let fc = g[8] + (S.defaultMods ? -2400 * (1 - vk) : 0);
                    if (fc <= 13500) {
                        const lp = ctx.createBiquadFilter();
                        lp.type = 'lowpass';
                        lp.frequency.value = Math.min(8.176 * Math.pow(2, fc / 1200), ctx.sampleRate * 0.49);
                        lp.Q.value = (g[9] || 0) / 10;
                        node.connect(lp); node = lp;
                    }
                    const amp = ctx.createGain();
                    node.connect(amp);
                    const pan = Math.max(-500, Math.min(500, g[17] || 0)) / 1000; // -0.5..0.5
                    if (Math.abs(pan) > 0.001) {
                        const sp = ctx.createStereoPanner();
                        sp.pan.value = pan * 2;
                        amp.connect(sp); sp.connect(ch.vol);
                    } else {
                        amp.connect(ch.vol);
                    }

                    const hold = g[35] + (g[39] || 0) * (60 - key);
                    const decay = g[36] + (g[40] || 0) * (60 - key);
                    const env = {};
                    env.a0 = when + tc2s(g[33]);
                    env.a1 = env.a0 + tc2s(g[34]);
                    env.h1 = env.a1 + (hold < -10000 ? 0 : tc2s(hold));
                    env.tau = Math.max(0.001, (decay < -10000 ? 0.001 : tc2s(decay)) / 9.226);
                    env.sus = Math.pow(10, -Math.max(0, Math.min(1440, g[37] || 0)) / 200);
                    env.rel = Math.max(0.01, Math.min(10, tc2s(g[38])));
                    const a = amp.gain;
                    a.setValueAtTime(0, when);
                    a.setValueAtTime(0, env.a0);
                    a.linearRampToValueAtTime(peak, env.a1);
                    a.setValueAtTime(peak, env.h1);
                    a.setTargetAtTime(peak * env.sus, env.h1, env.tau);

                    const v = { ch: c, key, src, amp, env, peak, excl: g[57] || 0, released: false, held: false };
                    src.onended = () => { const i = S.voices.indexOf(v); if (i >= 0) S.voices.splice(i, 1); };
                    src.start(when, Math.max(0, startOff) / buf.sampleRate);
                    S.voices.push(v);
                    started.push(v);
                }
                // Voice cap like SynthEngine's kMaxVoices: steal the oldest.
                const live = S.voices.filter(o => !o.released);
                for (let i = 0; i < live.length - 128; i++) release(live[i], when, true);
                return started;
            }

            S.ready = () => !!S.font;
            S.now = () => window.__mpsSynthCtx.currentTime;

            S.noteOn = function (c, key, vel) {
                const ctx = window.__mpsSynthCtx;
                if (!S.font || !ctx) return;
                if (ctx.state === 'suspended') ctx.resume();
                const t = ctx.currentTime;
                for (const o of S.voices) if (o.ch === c && o.key === key && !o.released) release(o, t, false);
                startVoice(c, key, vel, t);
            };

            S.noteOff = function (c, key) {
                const ctx = window.__mpsSynthCtx;
                if (!ctx) return;
                const ch = S.channels[c];
                for (const o of S.voices) {
                    if (o.ch !== c || o.key !== key || o.released || o.held) continue;
                    if (ch && ch.sustain) o.held = true; else release(o, ctx.currentTime, false);
                }
            };

            S.playNote = function (c, program, key, vel, start, end) {
                if (!S.font) return false;
                const ch = channel(c);
                ch.program = program;
                for (const v of startVoice(c, key, vel, start)) {
                    release(v, Math.max(end, start + 0.02), false);
                }
                return true;
            };

            S.cc = function (c, cc, value) {
                const ctx = window.__mpsSynthCtx;
                if (!ctx) return;
                const ch = channel(c), t = ctx.currentTime;
                if (cc === 7 || cc === 11) {
                    if (cc === 7) ch.cc7 = value; else ch.cc11 = value;
                    ch.vol.gain.setTargetAtTime(Math.pow((ch.cc7 / 127) * (ch.cc11 / 127), 3), t, 0.005);
                } else if (cc === 10) {
                    ch.pan.pan.setTargetAtTime((value - 64) / 64, t, 0.005);
                } else if (cc === 64) {
                    ch.sustain = value >= 64;
                    if (!ch.sustain) for (const o of S.voices) if (o.ch === c && o.held) { o.held = false; release(o, t, false); }
                } else if (cc === 120) {
                    for (const o of S.voices) if (o.ch === c) release(o, t, true);
                } else if (cc === 123) {
                    for (const o of S.voices) if (o.ch === c && !o.released) { if (ch.sustain) o.held = true; else release(o, t, false); }
                } else if (cc === 121) {
                    ch.cc7 = ch.cc11 = 127; ch.sustain = false;
                    ch.vol.gain.setTargetAtTime(1, t, 0.005);
                    ch.pan.pan.setTargetAtTime(0, t, 0.005);
                }
            };

            S.allOff = function () {
                const ctx = window.__mpsSynthCtx;
                for (const o of S.voices) {
                    try { o.amp.gain.cancelScheduledValues(0); o.amp.gain.value = 0; o.src.stop(); } catch (e) {}
                }
                S.voices = [];
                for (const ch of S.channels) if (ch) ch.sustain = false;
            };
        },
    'com.codesient.scoreflection.music.sound.sf2Load' : (url) => { window.__sfSampler.load(url); },
    'com.codesient.scoreflection.music.sound.sf2Ready' : () => !!(window.__sfSampler && window.__sfSampler.ready()),
    'com.codesient.scoreflection.music.sound.sf2PlayNote' : (channel, program, pitch, velocity, startSec, endSec) => (window.__sfSampler ? window.__sfSampler.playNote(channel, program, pitch, velocity, startSec, endSec) : false),
    'com.codesient.scoreflection.music.sound.sf2Now' : () => (window.__sfSampler ? window.__sfSampler.now() : 0),
    'com.codesient.scoreflection.music.sound.sf2AllOff' : () => { if (window.__sfSampler) window.__sfSampler.allOff(); },
    'com.codesient.scoreflection.music.sound.sf2SetProgram' : (channel, program) => { if (window.__sfSampler) window.__sfSampler.setProgram(channel, program); },
    'com.codesient.scoreflection.music.sound.sf2NoteOn' : (channel, pitch, velocity) => { window.__sfSampler.noteOn(channel, pitch, velocity); },
    'com.codesient.scoreflection.music.sound.oscNoteOn' : (key, freq, gain) => {
            const ctx = window.__mpsSynthCtx;
            if (!ctx) return;
            if (ctx.state === 'suspended') ctx.resume();
            if (!window.__mpsSynthVoices) window.__mpsSynthVoices = {};
            const voices = window.__mpsSynthVoices;
            const prev = voices[key];
            if (prev) { try { prev.osc.stop(); } catch (e) {} }
            const t = ctx.currentTime;
            const osc = ctx.createOscillator();
            const g = ctx.createGain();
            osc.type = 'triangle';
            osc.frequency.value = freq;
            g.gain.setValueAtTime(0.0001, t);
            g.gain.exponentialRampToValueAtTime(Math.max(gain, 0.0002), t + 0.01);
            osc.connect(g);
            g.connect(ctx.destination);
            osc.start(t);
            voices[key] = { osc: osc, gain: g };
        },
    'com.codesient.scoreflection.music.sound.sf2NoteOff' : (channel, pitch) => { if (window.__sfSampler) window.__sfSampler.noteOff(channel, pitch); },
    'com.codesient.scoreflection.music.sound.oscNoteOff' : (key) => {
            const ctx = window.__mpsSynthCtx;
            const voices = window.__mpsSynthVoices;
            if (!ctx || !voices) return;
            const v = voices[key];
            if (!v) return;
            const t = ctx.currentTime;
            try {
                v.gain.gain.cancelScheduledValues(t);
                v.gain.gain.setValueAtTime(v.gain.gain.value, t);
                v.gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.04);
                v.osc.stop(t + 0.06);
            } catch (e) {}
            delete voices[key];
        },
    'com.codesient.scoreflection.music.sound.oscAllOff' : () => {
            const voices = window.__mpsSynthVoices;
            if (!voices) return;
            for (const k in voices) { try { voices[k].osc.stop(); } catch (e) {} }
            window.__mpsSynthVoices = {};
        },
    'com.codesient.scoreflection.music.sound.sf2ControlChange' : (channel, cc, value) => { if (window.__sfSampler) window.__sfSampler.cc(channel, cc, value); },
    'com.codesient.scoreflection.music.sound.sf2SetDefaultModulators' : (enabled) => { if (window.__sfSampler) window.__sfSampler.defaultMods = enabled; },
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
    'kotlinx.io.getPlatformName' : 
        () => (typeof navigator !== "undefined" && navigator.platform) || "unknown"
    ,
    'kotlinx.io.node.persistModule' : 
        (globalThis.module = (typeof process !== 'undefined') && (process.release.name === 'node') ?
            await import(/* webpackIgnore: true */'node:module') : void 0, () => {})
    ,
    'kotlinx.io.node.getRequire' : () => { 
        const importMeta = import.meta;
        return globalThis.module.default.createRequire(importMeta.url);
    }
    ,
    'kotlinx.io.node.requireModule' : 
        (require, mod) => {
             try {
                 let m = require(mod);
                 if (m) return m;
                 return null;
             } catch (e) {
                 return null;
             }
        }
    ,
    'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
    'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
    'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util.date.Date_$external_fun' : () => new Date(),
    'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
    'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
    'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
    'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
    'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
    'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
    'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
    'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
    'io.ktor.util.hasNodeApi' : () => 
    (typeof process !== 'undefined' 
        && process.versions != null 
        && process.versions.node != null) ||
    (typeof window !== 'undefined' 
        && typeof window.process !== 'undefined' 
        && window.process.versions != null 
        && window.process.versions.node != null)
    ,
    'io.ktor.util.logging.getKtorLogLevel' : () => process ? process.env.KTOR_LOG_LEVEL : null,
    'io.ktor.util.logging.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
    'io.ktor.util.logging.console_$external_prop_getter' : () => console,
    'io.ktor.http.locationOrigin' : () => function() {
        var tmpLocation = null
        if (typeof window !== 'undefined') {
          tmpLocation = window.location
        } else if (typeof self !== 'undefined') {
          tmpLocation = self.location
        }
        var origin = ""
        if (tmpLocation) {
          origin = tmpLocation.origin
        }
        return origin && origin != "null" ? origin : "http://localhost"    
    }(),
    'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
    'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
    'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
    'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
    'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
    'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
    'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
    'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
    'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
    'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
    'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
    'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
    'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
    'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
    'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
    'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
    'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
    'io.ktor.client.utils.makeJsObject' : () => { return {}; },
    'io.ktor.client.utils.makeImport' : (name) => import(name),
    'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
    'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
    'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
    'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
    'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
    'io.ktor.client.utils.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
    'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
    'com.codesient.scoreflection.input.audio.micStart' : () => {
            if (window.__mpsMicState === 1 || window.__mpsMicState === 2) return;
            window.__mpsMicState = 1;
            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                window.__mpsMicState = 3;
                return;
            }
            // The AudioContext MUST be constructed and resumed synchronously, while
            // we are still inside the click handler. Creating it in the getUserMedia
            // .then() puts it outside the user gesture, and Firefox then leaves it
            // suspended forever.
            var ctx = new (window.AudioContext || window.webkitAudioContext)();
            if (ctx.state === 'suspended') ctx.resume();
            window.__mpsMicCtx = ctx;
            navigator.mediaDevices.getUserMedia({
                audio: {
                    echoCancellation: false,
                    noiseSuppression: false,
                    autoGainControl: false
                }
            }).then(function (stream) {
                if (ctx.state === 'suspended') ctx.resume();
                var src = ctx.createMediaStreamSource(stream);
                var an = ctx.createAnalyser();
                an.fftSize = 4096;               // time-domain window length
                an.smoothingTimeConstant = 0;    // no smoothing on raw samples
                src.connect(an);                 // NOT connected to destination
                // Retain every node: Firefox collects unreferenced Web Audio nodes
                // and the graph goes silent with no error.
                window.__mpsMicStream = stream;
                window.__mpsMicSrc = src;
                window.__mpsMicAnalyser = an;
                window.__mpsMicBuf = new Float32Array(an.fftSize);
                window.__mpsMicState = 2;
            }).catch(function () {
                window.__mpsMicState = 3;
            });
        },
    'com.codesient.scoreflection.input.audio.micState' : () => window.__mpsMicState ? window.__mpsMicState : 0,
    'com.codesient.scoreflection.input.audio.micStop' : () => {
            try {
                if (window.__mpsMicSrc) window.__mpsMicSrc.disconnect();
                if (window.__mpsMicAnalyser) window.__mpsMicAnalyser.disconnect();
                if (window.__mpsMicStream) { window.__mpsMicStream.getTracks().forEach(function (t) { t.stop(); }); }
                if (window.__mpsMicCtx) window.__mpsMicCtx.close();
            } catch (e) {}
            window.__mpsMicSrc = null;
            window.__mpsMicAnalyser = null;
            window.__mpsMicStream = null;
            window.__mpsMicCtx = null;
            window.__mpsMicBuf = null;
            window.__mpsMicState = 0;
        },
    'com.codesient.scoreflection.input.audio.micCapture' : () => {
            var an = window.__mpsMicAnalyser;
            var buf = window.__mpsMicBuf;
            if (!an || !buf) return 0;
            an.getFloatTimeDomainData(buf);
            return buf.length;
        },
    'com.codesient.scoreflection.input.audio.micSampleRate' : () => window.__mpsMicCtx ? Math.round(window.__mpsMicCtx.sampleRate) : 48000,
    'com.codesient.scoreflection.input.audio.micSample' : (i) => window.__mpsMicBuf ? window.__mpsMicBuf[i] : 0,
    'com.codesient.scoreflection.output.printer.printPages' : (pagesJson) => {
            const pages = JSON.parse(pagesJson);
            const frame = document.createElement('iframe');
            frame.setAttribute('aria-hidden', 'true');
            frame.style.position = 'fixed';
            frame.style.right = '0';
            frame.style.bottom = '0';
            frame.style.width = '0';
            frame.style.height = '0';
            frame.style.border = '0';
            document.body.appendChild(frame);
            const doc = frame.contentDocument;
            doc.open();
            doc.write('<!doctype html><html><head><meta charset="utf-8"><style>' +
                '@page { size: A4; margin: 0; }' +
                'html, body { margin: 0; padding: 0; }' +
                'img { display: block; width: 100%; page-break-after: always; }' +
                'img:last-child { page-break-after: auto; }' +
                '</style></head><body></body></html>');
            doc.close();
            let pending = pages.length;
            const ready = () => {
                pending -= 1;
                if (pending > 0) return;
                frame.contentWindow.focus();
                frame.contentWindow.print();
                // Leave the frame up long enough for the dialog to take its snapshot;
                // removing it synchronously after print() cancels the job in some
                // browsers.
                setTimeout(() => frame.remove(), 60000);
            };
            for (const src of pages) {
                const img = doc.createElement('img');
                img.onload = ready;
                img.onerror = ready;
                img.src = src;
                doc.body.appendChild(img);
            }
        },
    'com.codesient.scoreflection.ui.files.pickFileBytesJs' : (onPicked) => {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = '.mnx,.xml,.musicxml,.mxml,.mxl,.zip,.ly,.json,.abc,.cho,.chopro,.crd,.pro,.txt,.html,.gp';
            input.onchange = () => {
                const file = input.files && input.files[0];
                if (!file) return;
                const reader = new FileReader();
                reader.onload = () => {
                    const bytes = new Uint8Array(reader.result);
                    let binary = '';
                    const CHUNK = 0x8000;
                    for (let i = 0; i < bytes.length; i += CHUNK) {
                        binary += String.fromCharCode.apply(null, bytes.subarray(i, i + CHUNK));
                    }
                    onPicked(file.name, btoa(binary));
                };
                reader.readAsArrayBuffer(file);
            };
            input.click();
        },
    'com.codesient.scoreflection.ui.files.__convertKotlinClosureToJsClosure_((Js,Js)->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((Js,Js)->Unit)'](f, p0, p1)),
    'com.codesient.scoreflection.ui.files.linkedImportParam' : (key) => (new URLSearchParams(window.location.search).get(key) || ''),
    'com.codesient.scoreflection.ui.files.clearLinkedImportJs' : () => {
            const u = new URL(window.location.href);
            u.searchParams.delete('import');
            u.searchParams.delete('name');
            window.history.replaceState(null, '', u.pathname + u.search + u.hash);
        },
    'com.codesient.scoreflection.ui.files.fetchBytesJs' : (url, onLoaded, onFailed) => {
            fetch(url, { credentials: 'omit' })
                .then((r) => {
                    if (!r.ok) throw new Error('HTTP ' + r.status);
                    return r.arrayBuffer();
                })
                .then((buffer) => {
                    const bytes = new Uint8Array(buffer);
                    let binary = '';
                    const CHUNK = 0x8000;
                    for (let i = 0; i < bytes.length; i += CHUNK) {
                        binary += String.fromCharCode.apply(null, bytes.subarray(i, i + CHUNK));
                    }
                    onLoaded(btoa(binary));
                })
                .catch((e) => onFailed(String((e && e.message) || e)));
        },
    'com.codesient.scoreflection.ui.music.focusComposeCanvas' : () => {
            const typing = (el) => el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA');
            for (const host of document.querySelectorAll('*')) {
                const root = host.shadowRoot;
                if (!root) continue;
                const canvas = root.querySelector('canvas');
                if (!canvas) continue;
                if (!typing(root.activeElement) && !typing(document.activeElement)) canvas.focus();
                return;
            }
        },
    'com.codesient.scoreflection.ui.music.downloadText' : (filename, content) => {
            const blob = new Blob([content], { type: 'application/vnd.recordare.musicxml+xml' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            setTimeout(() => URL.revokeObjectURL(url), 10000);
        },
    'com.codesient.scoreflection.ui.music.studioParam' : () => (new URLSearchParams(window.location.search).get('studio') || ''),
    'com.codesient.scoreflection.ui.music.postToStudio' : (type, key, musicxml) => {
            if (window.parent === window) return;
            const msg = { type: type, key: key };
            if (type === 'sf-save') msg.musicxml = musicxml;
            window.parent.postMessage(msg, window.__sfStudioOrigin || '*');
        },
    'com.codesient.scoreflection.ui.music.addStudioListener' : (onLoad) => {
            const local = /^https?:\/\/(localhost|127\.0\.0\.1|\[::1\])(:\d+)?$/;
            const h = (e) => {
                if (e.source !== window.parent) return;
                if (!local.test(e.origin)) return;
                const d = e.data || {};
                if (d.type !== 'sf-load' || typeof d.text !== 'string') return;
                window.__sfStudioOrigin = e.origin;
                onLoad(String(d.key || ''), String(d.name || ''), String(d.title || ''), d.text);
            };
            window.addEventListener('message', h);
            return h;
        },
    'com.codesient.scoreflection.ui.music.__convertKotlinClosureToJsClosure_((Js,Js,Js,Js)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2, p3) => wasmExports['__callFunction_((Js,Js,Js,Js)->Unit)'](f, p0, p1, p2, p3)),
    'com.codesient.scoreflection.ui.music.removeStudioListener' : (handle) => window.removeEventListener('message', handle),
    'com.codesient.scoreflection.ui.tuner.toneStart' : (hz, seconds) => {
            if (!window.__mpsToneCtx || window.__mpsToneCtx.state === 'closed') {
                window.__mpsToneCtx = new (window.AudioContext || window.webkitAudioContext)();
            }
            var ctx = window.__mpsToneCtx;
            if (ctx.state === 'suspended') ctx.resume();
            if (window.__mpsToneOsc) { try { window.__mpsToneOsc.stop(); } catch (e) {} }
            var t = ctx.currentTime;
            var osc = ctx.createOscillator();
            var g = ctx.createGain();
            osc.type = 'sine';
            osc.frequency.value = hz;
            g.gain.setValueAtTime(0.0001, t);
            g.gain.exponentialRampToValueAtTime(0.25, t + 0.02);
            g.gain.setValueAtTime(0.25, t + seconds - 0.15);
            g.gain.exponentialRampToValueAtTime(0.0001, t + seconds);
            osc.connect(g);
            g.connect(ctx.destination);
            osc.start(t);
            osc.stop(t + seconds + 0.02);
            window.__mpsToneOsc = osc;
        },
    'com.codesient.scoreflection.ui.tuner.toneStop' : () => {
            if (window.__mpsToneOsc) { try { window.__mpsToneOsc.stop(); } catch (e) {} window.__mpsToneOsc = null; }
        },
    'com.codesient.scoreflection.web.pickTextFileJs' : (onLoaded) => {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = '.mnx,.xml,.musicxml,application/xml,text/xml';
            input.onchange = () => {
                const f = input.files && input.files[0];
                if (!f) return;
                const r = new FileReader();
                r.onload = () => onLoaded(f.name, String(r.result));
                r.readAsText(f);
            };
            input.click();
        },
    'com.codesient.scoreflection.web.audioStart' : () => {
            if (!window.__mpsCtx || window.__mpsCtx.state === 'closed') {
                window.__mpsCtx = new (window.AudioContext || window.webkitAudioContext)();
            }
            const ctx = window.__mpsCtx;
            if (ctx.state === 'suspended') ctx.resume();
            window.__mpsT0 = ctx.currentTime + 0.15;
            window.__mpsNodes = [];
        },
    'com.codesient.scoreflection.web.audioScheduleTone' : (freq, startSec, endSec, gain) => {
            const ctx = window.__mpsCtx;
            if (!ctx) return;
            const t0 = window.__mpsT0;
            const start = t0 + startSec;
            const end = Math.max(start + 0.05, t0 + endSec);
            const osc = ctx.createOscillator();
            const g = ctx.createGain();
            osc.type = 'triangle';
            osc.frequency.value = freq;
            g.gain.setValueAtTime(0.0001, start);
            g.gain.exponentialRampToValueAtTime(gain, start + 0.012);
            g.gain.setValueAtTime(gain, Math.max(start + 0.012, end - 0.04));
            g.gain.exponentialRampToValueAtTime(0.0001, end);
            osc.connect(g);
            g.connect(ctx.destination);
            osc.start(start);
            osc.stop(end + 0.03);
            window.__mpsNodes.push(osc);
        },
    'com.codesient.scoreflection.web.audioStop' : () => {
            if (window.__mpsNodes) {
                for (const n of window.__mpsNodes) { try { n.stop(); } catch (e) {} }
                window.__mpsNodes = [];
            }
        }
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    